<template class="loginbody">
  <div class="login-page">
      <b-overlay :show="overlay" rounded="sm">
        <div class="form">
            <form class="login-form" @submit="login" v-on:submit.prevent="login">
                <input focus type="text" :placeholder="$t('username')" v-model="loginData.username" required/>
                <input type="password" :placeholder="$t('password')" v-model="loginData.password" required/>
                <LangSwitcher style="margin-bottom:10px"/>
                <AppTimeZone/>
                <button type="submit" @click="login">{{ $t('login') }} </button>
            </form>
        </div>
      </b-overlay>
  </div>
</template>

<script>
import LangSwitcher from '@/components/langSwitcher'
import AppTimeZone from '@/components/appTimeZone'

export default {
  components: {
    LangSwitcher,
    AppTimeZone
  },
  data () {
    return {
      loginData: {
        username: '',
        password: ''
      },
      overlay: false
    }
  },
  methods: {
    login () {
      this.overlay = true
      try {
        let response = this.$store.dispatch('Login/POST_LOGIN', this.loginData)
        response.then(response => {
          let error = this.$store.getters['Login/LOGIN'].error
          if (error) {
            this.$bvToast.toast(this.$t(error), {
              title: this.$t('Error'),
              variant: 'danger',
              solid: true
            })
          } else {
            if (this.$store.getters['Login/LOGIN'].hasOwnProperty('session_id')) {
              this.$cookie.set('session_id', this.$store.getters['Login/LOGIN'].session_id, { expires: '1D' })
              this.$router.push('dashboard')
              this.$store.dispatch('Settings/GET_CORE_TIME_ZONE')
            }
          }
        })
      } finally {
        this.overlay = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue